import type { TravelRuleInfo } from "~/v2/api/rest/cryptoWallet";
import type { TravelRuleFormValues } from "./schema";

export function mapTravelRuleToFormDefaults(
  tr: TravelRuleInfo,
): Partial<TravelRuleFormValues> {
  return {
    beneficiary_is_self_hosted: tr.beneficiary_is_self_hosted ?? null,
    beneficiary_given_name: tr.beneficiary_given_name ?? "",
    beneficiary_family_name: tr.beneficiary_family_name ?? "",
    beneficiary_entity_name: tr.beneficiary_entity_name ?? "",
    beneficiary_vasp_id: tr.beneficiary_vasp_id ?? "",
    beneficiary_manual_entry: {
      vasp_name: tr.beneficiary_manual_entry?.vasp_name ?? "",
      vasp_website: tr.beneficiary_manual_entry?.vasp_website ?? "",
    },
    beneficiary_geographic_address_country:
      tr.beneficiary_geographic_address_country ?? "",
    beneficiary_geographic_address_building_number:
      tr.beneficiary_geographic_address_building_number ?? "",
    beneficiary_geographic_address_street_name:
      tr.beneficiary_geographic_address_street_name ?? "",
    beneficiary_geographic_address_town_name:
      tr.beneficiary_geographic_address_town_name ?? "",
    beneficiary_geographic_address_post_code:
      tr.beneficiary_geographic_address_post_code ?? "",
    beneficiary_country_of_residence: tr.beneficiary_country_of_residence ?? "",
  };
}
